import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { Order } from 'types/api/orders.type';

import { useAppSelector } from 'redux/hooks';
import { setTableCurrentPage, setTablePagination } from 'redux/slices/tableConfig';

import { ordersDataService } from 'services/orders.service';

import { useQueryParams } from 'hooks';

import { generateLastMonthDates } from 'helpers/generateLastMonthDates';

import { useColumns } from 'data/tableData/catalogue/ordersColumns';

import { useUsers } from 'pages/Users/Users.hooks';

import { statusFilter } from '../constants/filter';
import { getFilters } from '../constants/filters.data';

const useCustomerOrders = () => {
  useUsers();

  const { register, handleSubmit, control, reset, setValue } = useForm();

  const { params, setActiveQueries } = useQueryParams();
  const [currentOrders, setCurrentOrders] = useState<any>([]);
  const [restoreBtnClick, restoreBtnClickSet] = useState(false);
  const dispatch = useDispatch();
  const zones = useAppSelector((state) => state.constants.zones);
  const statuses = statusFilter;

  const { currentPage, size } = useAppSelector((state) => state.tableConfig.pagination);
  const tableSorting = useAppSelector((state) => state.tableConfig.sorting);
  const { datein, dateout } = generateLastMonthDates();
  const dateIn = params.get('datein') || datein;
  const dateOut = params.get('dateout') || dateout;
  const status = statuses.find((s: string) => s === params.get('status'));
  const customerCode = params.get('user');
  const columns = useColumns(restoreBtnClickSet);
  const filters = getFilters(statuses, zones);
  const [isLoading, setIsLoading] = useState(false);

  const onFirstLoad = async () => {
    setIsLoading(true);
    try {
      const res = await ordersDataService.getOrders(
        currentPage,
        size,
        tableSorting,
        dateIn !== null ? dateIn : undefined,
        dateOut !== null ? dateOut : undefined,
        params.get('zone') || undefined,
        status,
        customerCode || undefined
      );
      if (res.data.content) {
        const remap = res.data.content.map((o: Order) => ({
          ...o,
          eliminated: o.status === 'DELETED',
          action: ['view'],
        }));
        setCurrentOrders(remap);
        dispatch(setTablePagination({ totalPages: res.data.totalPages }));
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const onSubmit = (filtersData: FieldValues) => {
    Object.keys(filtersData).forEach((key) => {
      if (filtersData[key] === undefined || filtersData[key] === '') {
        delete filtersData[key];
      }
    });
    dispatch(setTableCurrentPage(0));

    setActiveQueries(filtersData);
  };

  useEffect(() => {
    onFirstLoad();
  }, [params, currentPage, size, tableSorting, columns, restoreBtnClick]);

  return {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    params,
    onSubmit,
    filters,
    columns,
    currentOrders,
    isLoading,
  };
};

export { useCustomerOrders };
